import React from 'react';
import { FiltersSidebar, Header, Trials } from './components';
import { useTrialsFilters } from './hooks';
import './styles.css';

const TrialsLibrary = () => {
  const {
    count,
    trials,
    filters,
    orderBy,
    countries,
    searchString,
    orderDirection,
    isActiveStatus,
    overallStatuses,
    isTrialsLoading,
    paginationParams,
    clearAllFilters,
    handleSearchChange,
    handleOrderByChange,
    handleLocationChange,
    handleCountriesChange,
    handleCategoryIdsChange,
    handleStatusSwitchChange,
    handleLeadSponsorsChange,
    handleOverallStatusChange,
    handleOrderDirectionChange,
  } = useTrialsFilters();

  return (
    <section id="trials-library" className="max-h-screen">
      <Header />
      <div className="flex">
        <FiltersSidebar filters={filters} />
        <Trials
          count={count}
          trials={trials}
          orderBy={orderBy}
          countries={countries}
          searchString={searchString}
          isActiveStatus={isActiveStatus}
          orderDirection={orderDirection}
          overallStatuses={overallStatuses}
          isTrialsLoading={isTrialsLoading}
          paginationParams={paginationParams}
          clearAllFilters={clearAllFilters}
          handleSearchChange={handleSearchChange}
          handleOrderByChange={handleOrderByChange}
          handleLocationChange={handleLocationChange}
          handleCountriesChange={handleCountriesChange}
          handleCategoryIdsChange={handleCategoryIdsChange}
          handleStatusSwitchChange={handleStatusSwitchChange}
          handleLeadSponsorsChange={handleLeadSponsorsChange}
          handleOverallStatusChange={handleOverallStatusChange}
          handleOrderDirectionChange={handleOrderDirectionChange}
        />
      </div>
    </section>
  );
};

export default TrialsLibrary;
